import { render, staticRenderFns } from "./OrganizePage.vue?vue&type=template&id=0e9b1000"
import script from "./OrganizePage.vue?vue&type=script&lang=js"
export * from "./OrganizePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports